import { Location } from '@core/Router/locations';
import { lazy } from 'react';
import { ENTRY_PAGE_PATH } from './consts';

const PatientListPageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/PatientListPage').then(m => ({ default: m.PatientListPage })),
);
const MergePatientPageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/MergePatientPage').then(m => ({
        default: m.MergePatientPage,
    })),
);
const EhrPageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/EhrPage').then(m => ({ default: m.EhrPageAccessGuard })),
);
const EntryReportPages = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/EntryReportPage').then(m => ({
        default: m.EntryReportPage,
    })),
);
const EntryLegacyReportPageContainer = lazy(() =>
    // eslint-disable-next-line no-restricted-syntax -- route mount point for legacy-format entries
    import(/* webpackChunkName: "patient" */ '@modules/patient/ui/LegacyEntryPage').then(m => ({
        default: m.EntryLegacyReportPage,
    })),
);
const MedicalCasePageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/MedicalCasePage').then(m => ({ default: m.MedicalCasePage })),
);
const PatientTitleListPageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/PatientTitleListPage').then(m => ({
        default: m.PatientTitleListPage,
    })),
);
const PatientTitleListPageGeoContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/PatientTitleListPageGeo/PatientTitleListPageGeo').then(m => ({
        default: m.PatientTitleListPageGeo,
    })),
);
const InformedConsentContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/InformedConsent/InformedConsent').then(m => ({
        default: m.InformedConsent,
    })),
);
const VaccinationCertificatePageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@patient/ui/EhrPage/pages/VaccinationCertificatePage').then(m => ({
        default: m.VaccinationCertificatePage,
    })),
);
const SoapEntryPageContainer = lazy(() =>
    import(/* webpackChunkName: "patient" */ '@modules/patient/ui/SoapEntryPage').then(m => ({
        default: m.SoapEntryPage,
    })),
);
const EntryFeatureContainer = lazy(() =>
    // eslint-disable-next-line no-restricted-syntax -- route mount point for legacy-format entries
    import(/* webpackChunkName: "patient" */ '@patient/ui/LegacyEntryPage/EntryFeature').then(m => ({
        default: m.EntryFeature,
    })),
);

export const patientLocations: Location[] = [
    {
        url: '/patient',
        Component: PatientListPageContainer,
    },
    {
        url: '/merge',
        Component: MergePatientPageContainer,
    },
    {
        url: '/informed-consent',
        Component: InformedConsentContainer,
    },
    {
        url: '/patient/:patientId',
        Component: EhrPageContainer,
    },
    {
        url: '/patient/:patientId/title-list',
        Component: PatientTitleListPageContainer,
    },
    {
        url: '/patient/:patientId/title-list-geo',
        Component: PatientTitleListPageGeoContainer,
    },
    {
        url: ENTRY_PAGE_PATH,
        Component: EntryFeatureContainer,
    },
    {
        url: '/patient/:patientId/entry/:entryId/soap',
        Component: SoapEntryPageContainer,
    },
    {
        url: '/patient/:patientId/entry/:entryId/report',
        Component: EntryReportPages,
    },
    {
        url: '/patient/:patientId/entry/:entryId/report/legacy',
        Component: EntryLegacyReportPageContainer,
    },
    {
        url: '/patient/:patientId/vaccination',
        Component: VaccinationCertificatePageContainer,
    },
    {
        url: '/patient/:patientId/medical-case/:medicalCaseId',
        Component: MedicalCasePageContainer,
    },
];
